<template>
  <main class="dashboard-page">
    <section class="dashboard-shell">
      <app-header
        :isFormPage="false"
        @show-drawer="showDrawer"
        @logout="logout"
      />
      <div class="dashboard-tabs">
        <q-tabs v-model="activeTab" dense class="">
          <!-- <q-tab  name="dashboard" label="Dashboard" /> -->
          <q-tab v-if="userHaveVisitRights" name="visit" label="Visits" />
          <q-tab v-if="userHaveProjectRights" name="project" label="Projects" />
        </q-tabs>
      </div>
      <q-tab-panels v-model="activeTab" animated>
        <q-tab-panel name="dashboard">
          <dashboard-tab
            :userHaveVisitRights="userHaveVisitRights"
            :userHaveProjectRights="userHaveProjectRights"
            :userHaveDashBoardRights="userHaveDashBoardRights"
            @go-to-tab="activeTab = $event"
            ref="dasboardTab"
          />
        </q-tab-panel>

        <q-tab-panel name="visit">
          <visit-dashboard />
        </q-tab-panel>
        <q-tab-panel name="project">
          <project-dashboard />
        </q-tab-panel>
      </q-tab-panels>
      <drawer ref="refDrawer" />
    </section>
  </main>
</template>
<script>
import appHeader from "@/views/components/header.vue";
import Drawer from "@/views/layout/drawer.vue";
import projectDashboard from "@/views/project/projectDashboard.vue";
import visitDashboard from "@/views/visitDashboard.vue";
import dashboardTab from "@/views/dashboardTab.vue";

export default {
  components: {
    Drawer,
    appHeader,
    projectDashboard,
    visitDashboard,
    dashboardTab,
  },
  mounted() {
    setTimeout(() => {
      this.callInitialFunctions();
    }, 100);
  },
  data() {
    return {
      activeTab: "visit",
      userHaveProjectRights: false,
      userHaveVisitRights: false,
      userHaveDashBoardRights: false,
    };
  },

  methods: {
    callInitialFunctions() {
      const dasboardMenu = this.$store.state.menus?.some(
        (m) => m.menuUrl == "/Dashboard"
      );
      const projectMenu = this.$store.state.menus?.some(
        (m) => m.menuUrl == "/project-list"
      );
      const visitMenu = this.$store.state.menus?.some(
        (m) => m.menuUrl == "/visit-form-list"
      );
      console.log("projectMenu: ", projectMenu);

      if (projectMenu) {
        this.userHaveProjectRights = true;
      } else this.userHaveProjectRights = false;
      if (visitMenu) {
        this.userHaveVisitRights = true;
      } else this.userHaveVisitRights = false;
      if (dasboardMenu) {
        this.userHaveDashBoardRights = true;
      } else this.userHaveDashBoardRights = false;

      setTimeout(() => {
        if (this.$refs.dasboardTab) {
          this.$refs.dasboardTab.loadAll();
        }
      }, 100);
    },
    setMenu(url){
      const menu = this.$store.state.menus.find(m => m.menuUrl == url)
    this.$store.commit('setMenu', menu)
    console.log('url: ', url);
    console.log('menu: ', menu);
    },
    showDrawer() {
      if (this.$refs.refDrawer) {
        this.$refs.refDrawer.toggleDrawer();
      }
    },
    logout() {
      sessionStorage.setItem("token", null);
      this.$store.commit("logOutHandler");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/quasar.scss";
.dashboard-tabs {
  display: flex;
  justify-content: start;
  padding: 7px;
}

.dashboard-page {
  min-height: 100vh;
  padding: 0;
  color: $primary;
  text-align: left;
}
.dashboard-shell {
  max-width: 100%;
  margin: 0 auto;
}

@media (min-width: 641px) {
  .dashboard-page {
    padding: 32px 16px;
  }
}

@media (min-width: 1201px) {
  .dashboard-shell {
    max-width: 80vw;
    margin: 0 auto;
  }
}
</style>
